// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4073":"82d0836e75ecf7d5","7615":"c2fc2a186294abb6"}[chunkId] + ".css";
};